module.exports = __webpack_public_path__ + "static/media/Robot Warrior.b0477e7a.jpg";